/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Kits_Region_GlobalInputs */

const en_fw_kits_region_global = /** @type {(inputs: Fw_Kits_Region_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Global`)
};

const id_fw_kits_region_global = /** @type {(inputs: Fw_Kits_Region_GlobalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Global`)
};

/**
* | output |
* | --- |
* | "Global" |
*
* @param {Fw_Kits_Region_GlobalInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_kits_region_global = /** @type {((inputs?: Fw_Kits_Region_GlobalInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Kits_Region_GlobalInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_kits_region_global(inputs)
	return en_fw_kits_region_global(inputs)
});